import React from "react";
/*eslint-disable */

interface GarantiaComponentProps {
  warranty: any;
}
const GarantiaComponent: React.FC<GarantiaComponentProps> = ({ warranty }) => {
  return (
    <div className="garantia-posventa-garantia-container">
      {/* <div className="title-garantia-posventa-garantia-container">Garantía</div> */}
      <div className="cars-garantia-posventa-garantia-container">
        {warranty?.map((item: any, index: number) => (
          <div className="car" key={index}>
            <img 
              className="vehicle" 
              src={`https://manager.hyundaicolombia.co/${item?.media?.url}`} 
              alt={item?.title ? `Imagen de ${item.title}` : "Imagen del vehículo"} 
            />
            <div className="title">{item?.title}</div>
            <img 
              className="sello" 
              src={`https://manager.hyundaicolombia.co/${item?.icon?.url}`} 
              alt={item?.title ? `Sello de garantía para ${item.title}` : "Sello de garantía"} 
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default GarantiaComponent;
